module.exports = __webpack_public_path__ + "img/logo_infostock.3d527a2.png";